const announcements = {
  path: 'announcements/:myClassId',
  props: true,
  component: resolve => require(['../../../../components/pages/student_user/announcements'], resolve)
}
export default announcements
